export default __webpack_public_path__ + "assets/10.df0fcaee.png";